<template>
  <div class="question-view-dialog" >
    <div class="quest">
      <div class="title">
        <vue-mathjax :formula="form.title" :safe="false"/>
      </div>
      <div class="choice-list">
        <div :class="['single', its.check && 'single-select']" :data-id="its.id" :data-idx="its.idx"
         v-for="(its, idx) in choice_option" :key="idx" @click="clickChoice(idx, its.id)">
          <span class="single-letter">{{ letter[idx] }}.</span>
          <span class="single-cte" v-if="its.type == '0'">
            <vue-mathjax :formula="its.choice" :safe="false"/>
          </span>
          <img v-else class="single-img" :src="its.choice" alt="">
        </div>
      </div>
    </div>
    <div class="quest-img" v-if="form.img_url || form.imgUrl" @click="$emit('urlToParent', form.img_url || form.imgUrl)">
      <img :src="form.img_url || form.imgUrl" :style="imgStyle" alt="">
    </div>
  </div>
</template>

<script>

export default {
  props: ['form', 'mode'],
  data() {
    let letter = new Array(26).fill().map((its, idx) => its = String.fromCharCode(65 + idx))

    return {
      letter,
      choice_option: [],
      imgStyle: null,
      answer_results: {
        id: null,
        student_choices: []
      },
      bodyWidth: 1960,
      // 记录题目及答案
      recordQuestion: null
    }
  },
  watch: {
    'form.id': {
      handler() {
        this.initData()
      },
      deep: true
    },
  },
  methods: {
    getBodyWidth() {
      let body = document.querySelector('.dialog-preview .body')
      // console.log(body)

      return body.offsetWidth;
    },
    showTrueFalse() {
      let { form, recordQuestion } = this,
      answers = form.answers.map(its => its.choice_id),
      blocks = document.querySelectorAll('.choice-list .single')

      for(let i = 0; i < blocks.length; i++) {
        let block = blocks[i],
        id = Number(block.dataset.id)
        block.setAttribute('class', 'single')
        if(recordQuestion.includes(id)) {
          block.classList.add('single-select')

          if(answers.includes(id)) {
            block.classList.add('determine-success-br')
          } else if(block.classList.contains('single-select')){
            block.classList.add('determine-error-br')
          }
        }
      }
    },
    clickChoice(idx) {
      this.choice_option[idx].check = !this.choice_option[idx].check
      this.$emit('permissions', true)

      this.recordQuestion = []
      this.answer_results.student_choices = []
      this.choice_option.map(its => {
        if(its.check) {
          this.recordQuestion.push(Number(its.id))
          this.answer_results.student_choices.push({choice_id: Number(its.id), value: ''})
        }
      })
    },
    initData() {
      this.answer_results = {
        id: null,
        student_choices: []
      }
      // 记录题目及答案
      this.recordQuestion = null
      this.choice_option = []
      
      this.choice_option = this.form.choices.map((its, idx) => {
        let choice = its.value.substring(its.value.indexOf('.') + 1)
        if(choice) return { ...its, choice, idx, check: false}
      }).filter(its => its)

      // console.log(this.choice_option)
      if(this.mode == 'viewAnswer') setTimeout(() => this.showTrueFalse(), 500)
      
      this.$nextTick(() => {
        // 还原答案
        let answers = this.form.answers,
        singles = document.querySelectorAll('.dialog-preview .single')
        for(let i = 0; i < answers.length; i++) {
          let value = answers[i].value

          n:
          for(let n = 0; n < singles.length; n++) {
            let single = singles[n]
            , idx = single.dataset.idx

            if(idx == value) {
              single.classList.add('determine-success-br')
              break n
            }
          }
        }
      })
    }
  },
  // created() {
  //   console.log(this.form)
  // },
  mounted() {
    this.initData()
    this.bodyWidth = this.getBodyWidth()
    
    window.onresize = () => {
      this.bodyWidth = this.getBodyWidth()
      // console.log(this.bodyWidth)
    } 
  }
}
</script>

<style scoped lang="scss">
.question-view-dialog {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 10px;
  .quest {
    // width: calc(55% - 10px);
    flex:1 ;
    height: 100%;
    .title {
      font-size: 15px;
      color: #333;
    }
    .choice-list {
      margin-top: 20px;
      width: calc(55% - 10px);
      padding: 0;
      .single {
        width: 80%;
        padding: 10px;
        box-sizing: border-box;
        border-radius: 10px;
        border: 2px solid #fcd2ab;
        background-color: #fcd2ab;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 10px;
        cursor: pointer;
        .single-letter {
          font-size: 15px;
          // font-weight: 700;
          margin-right: 5px;
        }
        .single-cte {
          font-size: 13px;
        }
        .single-img {
          width: 80px;
          height: 80px;
          object-fit: contain;
        }

        &:hover {
          opacity: .8;
        }
      }
      .single-select {
        border-color: #d37525;
        background-color: #f8ae64;
      }
    }
  }
  .quest-img {
    max-width: 40%;
    flex: 1;
    max-height: 500px;
    aspect-ratio: 833/500;
    display: flex;
    align-items: flex-start;
    justify-content: center;

    img {
      width: 100%;
      height: auto;
      border-radius: 5px;
    }
  }
}
</style>